


















import { Component } from 'vue-property-decorator';
import MenuSelectBase from '@/components/menu/menu-select/MenuSelectBase';
import MenuSelectPopup from '@/components/popups/menu-select-popup/MenuSelectPopup.vue';
import { SubMenuModel } from '@/models/SubMenuModel';

@Component({
  components: { MenuSelectPopup },
})
export default class MenuSelectMobile extends MenuSelectBase {
  private isPopupOpen = false;

  private onMenuSelected(value: SubMenuModel): void {
    this.isPopupOpen = false;
    this.onSelected(value);
  }
}
